import { withStyles } from '@material-ui/core';
import Action from '../../common/components/CardAction';
import styles from './styles';
import { getDowLocationCardDetails } from '../../utils';

const DOWDisplayCard = ({
  location,
  openForm,
  selectPolygonOnMap,
  onDelete,
  classes,
  isSelectedOnMap
}) => {
  const labelsList = getDowLocationCardDetails(location.dowDelWindow);
  return (
    <div
      className={`${classes.container} ${isSelectedOnMap ? classes.highlightedCard : ''}`}
      onClick={() => selectPolygonOnMap([location.locationMappingId])}>
      <div className={classes.cardContainer}>
        <span className={classes.locationName}>{location.locationName}</span>
        <div className={classes.equipContainer}>
          {labelsList.map((labelItem, index) => (
            <>
              <span className={`${classes.equipmentLabel} ${index ? classes.divider : ''}`}>
                {labelItem.label}:
              </span>
              <span className={classes.equipmentValue}>{labelItem.value}</span>
            </>
          ))}
        </div>
      </div>
      <Action
        onEdit={() => openForm(location.locationMappingId)}
        onDelete={() => onDelete(location)}
      />
    </div>
  );
};

export default withStyles(styles)(DOWDisplayCard);
